import { useQuery } from '@tanstack/react-query';
import { getStats } from '../api';

export const statsKeys = {
  all: ['stats'],
};

export function useStats(options = {}) {
  return useQuery({
    queryKey: statsKeys.all,
    queryFn: async () => {
      const res = await getStats();
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
